import React from "react";
import "./Classes.css";
import PaginationTable from "../../components/paginationTable/PaginationTable";
import { textFilter } from "react-bootstrap-table2-filter";
import CamplaCoreService from "../../services/CamplaCoreService";
import CreateClassDialog from "./dialogs/createClassDialog/CreateClassDialog";
import Button from "react-bootstrap/Button";
import UpdateClassDialog from "./dialogs/updateClassDialog/UpdateClassDialog";
import UnsavedChangesDialog from "../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import ShowMembersDialog from "./dialogs/showMembersDialog/ShowMembersDialog";
import ClassActionCell from "./classActionCell/ClassActionCell";
import StorageService from "../../services/StorageService";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import {
  Col,
  Container,
  DropdownButton,
  Row,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AuxiliumImport from "../../plugins/classes/auxiliumImport/AuxiliumImport";
import MoodleImport from "../../plugins/classes/moodleImport/MoodleImport";
import CSVImport from "../../plugins/classes/csvImport/CSVImport";
import ISAcademiaImport from "../../plugins/classes/isacademiaImport/ISAcademiaImport";
import DeleteDialog from "../../components/dialogs/deleteDialog/DeleteDialog";
import PaginationTableFilterToggle from "../../components/paginationTableFilterToggle/PaginationTableFilterToggle";

class Classes extends React.Component {
  tableId = "classesTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.tableConfigShowFilters(this.tableId);
    this.state = {
      classes: [],
      showCreateClassModal: false,
      showDeleteSelectedClassesModal: false,
      showDeleteSingleClassModal: false,
      showUpdateClassModal: false,
      showMembersModal: false,
      showUnsavedChangesDialog: false,
      closeAction: () => {},
      classToDeleteOrEdit: null,
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      dialogApiError: "",
      apiError: "",
      cachedModuleClasses: [],
      associatedModuleClasses: [],
    };

    this.handleCreateClass = this.handleCreateClass.bind(this);
    this.handleUpdateClass = this.handleUpdateClass.bind(this);
    this.handleDeleteClass = this.handleDeleteClass.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
    this.importFromExternalSource = this.importFromExternalSource.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();

    try {
      let classes = StorageService.getReferenceType("classes");
      let cachedModuleClasses = StorageService.getReferenceType(
        "extendedModuleClasses"
      );

      if (cachedModuleClasses) {
        this.setState({ cachedModuleClasses });
      }

      if (classes) {
        this.setState({ classes: classes });
      }
      classes = await CamplaCoreService.getAllClasses();
      cachedModuleClasses = await CamplaCoreService.getAllModuleClasses();
      StorageService.set("classes", classes);
      StorageService.set("extendedModuleClasses", cachedModuleClasses);
      this.setState({ classes, cachedModuleClasses });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ apiError: "" });
          },
          {},
          this.props.t
        ),
      });
    }
  }

  importFromExternalSource(imported) {
    const user = StorageService.getUser();
    const userEmail =
      user && typeof user["email"] !== "undefined" ? user["email"] : "";
    const newClasses = [...this.state.classes];
    const newCachedModuleClasses = [...this.state.cachedModuleClasses];
    if (imported.class) {
      if (Array.isArray(imported.class)) {
        imported.class.forEach((c) => {
          c["user"] = userEmail;
          newClasses.push(c);
        });
        imported.moduleClass.forEach((c) => newCachedModuleClasses.push(c));
      } else {
        imported.class["user"] = userEmail;
        newClasses.push(imported.class);
        newCachedModuleClasses.push(imported.moduleClass);
      }
      this.setState({
        classes: newClasses,
        cachedModuleClasses: newCachedModuleClasses,
      });
    }
  }

  async handleCreateClass(classToCreate) {
    try {
      const createdClass = await CamplaCoreService.createClass(classToCreate);
      createdClass["user"] = StorageService.getUser()
        ? StorageService.getUser().email
        : "";
      this.state.classes.push(createdClass);
      this.setState({
        showCreateClassModal: false,
        classes: Object.assign([], this.state.classes),
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Classes.APIError.PreconditionFailed",
          },
          this.props.t
        ),
      });
    }
  }

  async handleUpdateClass(changedClass) {
    try {
      const updatedClass = await CamplaCoreService.updateClass(
        this.state.classToDeleteOrEdit._id,
        changedClass
      );
      let index = this.state.classes
        .map((c) => c._id)
        .indexOf(this.state.classToDeleteOrEdit._id);
      if (index !== -1) {
        // eslint-disable-next-line
        updatedClass["user"] = this.state.classes[index]["user"];
        this.state.classes[index] = updatedClass;
      }
      this.setState({
        showUpdateClassModal: false,
        classes: Object.assign([], this.state.classes),
        classToDeleteOrEdit: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Classes.APIError.PreconditionFailed",
            NOT_FOUND: "Classes.APIError.NotFound",
            CONFLICT: "Classes.APIError.DeleteConflict",
          },
          this.props.t
        ),
      });
    }
  }

  async deleteAssociatedModuleClasses() {
    for (let i = 0; i < this.state.associatedModuleClasses.length; i++) {
      await CamplaCoreService.deleteModuleClass(
        this.state.associatedModuleClasses[i]._id
      );
    }
  }

  handleOnDelete(sClass) {
    let associatedModuleClasses = this.state.cachedModuleClasses.filter(
      (mc) => mc.classId === sClass._id
    );
    this.setState({
      classToDeleteOrEdit: sClass,
      associatedModuleClasses: associatedModuleClasses,
      showDeleteSingleClassModal: true,
    });
  }

  async handleDeleteClass() {
    if (this.state.associatedModuleClasses.length > 0) {
      try {
        await this.deleteAssociatedModuleClasses();
      } catch (err) {
        this.setState({
          dialogApiError: APIErrorHelper.getError(
            err,
            () => {
              this.setState({ dialogApiError: "" });
            },
            {
              PRECONDITION_FAILED: "ModuleClasses.APIError.PreconditionFailed",
              NOT_FOUND: "ModuleClasses.APIError.NotFound",
              CONFLICT: "ModuleClasses.APIError.DeleteConflict",
            },
            this.props.t
          ),
        });
        return;
      }
    }
    try {
      await CamplaCoreService.deleteClass(this.state.classToDeleteOrEdit._id);
      this.setState({
        showDeleteSingleClassModal: false,
        classes: this.state.classes.filter(
          (x) => x._id !== this.state.classToDeleteOrEdit._id
        ),
        classToDeleteOrEdit: null,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: "Classes.APIError.PreconditionFailed",
            NOT_FOUND: "Classes.APIError.NotFound",
            CONFLICT: "Classes.APIError.DeleteConflict",
          },
          this.props.t
        ),
      });
    }
  }

  render() {
    const { t } = this.props;

    const columns = [
      {
        dataField: "name",
        text: t("Classes.ColumnName"),
        sort: true,
        filter: textFilter({
          placeholder: t("Classes.FilterNamePlaceholder"),
          style: { width: "auto", display: this.state.displayFilter },
        }),
      },
      {
        dataField: "user",
        text: t("Classes.ColumnOwner"),
        sort: true,
        filter: textFilter({
          placeholder: t("Classes.FilterOwnerPlaceholder"),
          style: { width: "auto", display: this.state.displayFilter },
        }),
      },
      {
        dataField: "members",
        text: t("Classes.ColumnMembercount"),
        sort: true,
        formatter: (cell, row) => {
          return <span> {cell.length} </span>;
        },
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
            <PaginationTableFilterToggle
                onFilterToggle={(e) => {
                  this.setState({
                    showFilters: e.currentTarget.checked,
                    displayFilter: e.currentTarget.checked ? "initial" : "none",
                  });
                }}
                showFilters={this.state.showFilters}
                tableId={this.tableId} />
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, sClass) => (
          <ClassActionCell
            onShowMembers={() => {
              this.setState({
                showMembersModal: true,
                classToDeleteOrEdit: sClass,
              });
            }}
            onEdit={() => {
              this.setState({
                showUpdateClassModal: true,
                classToDeleteOrEdit: sClass,
              });
            }}
            onDelete={() => this.handleOnDelete(sClass)}
            class={sClass}
          />
        ),
      },
    ];

    return (
      <div>
        <CreateClassDialog
          show={this.state.showCreateClassModal}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    dialogApiError: null,
                    showCreateClassModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateClassModal: false,
              });
            }
          }}
          onSubmit={this.handleCreateClass}
        />

        <DeleteDialog
          show={this.state.showDeleteSingleClassModal}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              dialogApiError: null,
              showDeleteSingleClassModal: false,
            })
          }
          onSubmit={this.handleDeleteClass}
          title={t("Classes.ClassModal.DeleteModal.Title")}
          body={
            <div>
              {this.state.associatedModuleClasses.length === 0 &&
                t("Classes.ClassModal.DeleteModal.Text", {
                  className: this.state.classToDeleteOrEdit?.name,
                })}
              {this.state.associatedModuleClasses.length > 0 && (
                <div>
                  {t("Classes.ClassModal.DeleteModal.DeleteModuleClassesText", {
                    className: this.state.classToDeleteOrEdit?.name,
                  })}
                </div>
              )}
            </div>
          }
          rightButtonText={t("Classes.ClassModal.DeleteModal.Confirm")}
          leftButtonText={t("DialogCancel")}
        />

        <UpdateClassDialog
          show={this.state.showUpdateClassModal}
          dialogApiError={this.state.dialogApiError}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showUpdateClassModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showUpdateClassModal: false,
              });
            }
          }}
          onSubmit={this.handleUpdateClass}
          class={this.state.classToDeleteOrEdit}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />
        <ShowMembersDialog
          show={this.state.showMembersModal}
          onHide={() => this.setState({ showMembersModal: false })}
          class={this.state.classToDeleteOrEdit}
        />
        <Container className="mt-3">
          <Row className="pageTitle">
            <Col>
              <h2>{t("Classes.Title")}</h2>
            </Col>
            <Col>
              <div style={{ float: "right" }}>
                <Button
                  className="btn-green ml-3"
                  onClick={() => {
                    this.setState({ showCreateClassModal: true });
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>
              <div style={{ float: "right" }}>
                <DropdownButton
                  onClick={(event) => event.stopPropagation()}
                  id="dropdown-basic-button"
                  title={t("Classes.ImportButton")}
                  className="btn-green"
                >
                  {typeof window.plugins["auxilium"] !== "undefined" &&
                  typeof window.plugins["auxilium"]["enable"] !== "undefined" &&
                  typeof window.plugins["auxilium"]["enable"] ? (
                    <AuxiliumImport
                      className="btn-fhnw"
                      onCreate={this.importFromExternalSource}
                    />
                  ) : (
                    ""
                  )}
                  {typeof window.plugins["isacademia"] !== "undefined" &&
                  typeof window.plugins["isacademia"]["enable"] !==
                    "undefined" &&
                  typeof window.plugins["isacademia"]["enable"] ? (
                    <ISAcademiaImport
                      className="btn-fhnw"
                      onCreate={this.importFromExternalSource}
                    />
                  ) : (
                    ""
                  )}
                  <MoodleImport
                    className="btn-moodle"
                    onCreate={this.importFromExternalSource}
                  />
                  <CSVImport
                    className="btn-moodle"
                    onCreate={this.importFromExternalSource}
                  />
                </DropdownButton>
              </div>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <PaginationTable
                data={this.state.classes}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="_id"
                ref={this.paginationTableRef}
                id={this.tableId}
                view="classes"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(Classes);
